// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"9":"9a2fdb1c","54":"b5905a42","601":"379747ed","626":"cdd47627","851":"4b4c99a7","926":"169e133a","948":"52d1905f"}[chunkId] + ".js";
};